var array = [], lng = 10.4820741, lat = -66.8638721;
var map_store, infoWindows_store, marker_store, geocoder_store;
var Latlng;

// --- NUEVO: banderas para saber cuál async terminó primero ---
var datosListos = false;
var mapaListo = false;

$(function () {
  $.ajax({
    url: 'https://cdn.shopify.com/s/files/1/0607/2372/4530/files/storeVenezuela.csv?v=1778041815',
    dataType: 'text',
    scriptCharset: "UTF-8",
  }).done(getStore);
});

function getStore(data) {
  var country = 'Venezuela';
  var state = 0;
  var allRows = data.split(/\r?\n|\r/);

  for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
    var rowCells = allRows[singleRow].split(',');
    if (rowCells[0] != null && rowCells[7] != undefined) {
      if (rowCells[7] == country || quitarAcentos(rowCells[7].toUpperCase()) == quitarAcentos(country.toUpperCase())) {

        var name_final = rowCells[4];
        var entrada = {
          name: rowCells[0],
          mobile: rowCells[1] + ' ' + rowCells[11],
          email: rowCells[2],
          direction: rowCells[3],
          lat: rowCells[5],
          lng: rowCells[6],
          lv: rowCells[8],
          service: rowCells[9],
          img: rowCells[10]
        };

        if (array.length == 0) {
          array.push({ city: name_final, data: [entrada] });
        } else {
          state = 0;
          for (var i = 0; i < array.length; i++) {
            if (name_final == array[i]['city']) {
              array[i]['data'].push(entrada);
              state = 1;
            }
          }
          if (state == 0) {
            array.push({ city: name_final, data: [entrada] });
          }
        }
      }
    }
  }

  // Construir el HTML de los dropdowns
  var html = '';
  for (var singleRow = 0; singleRow < array.length; singleRow++) {
    var name_store = "<ul class='dropdown-menu dropdown-menu-right'>";
    var city = "<div class='dropdown'><button id='" + singleRow + "' class='drop-tiendas btn-tiendas dropdown-toggle' type='button' data-toggle='dropdown'>" + array[singleRow]['city'] + "<span class='caret'></span></button>";
    for (var j = 0; j < array[singleRow]['data'].length; j++) {
      name_store += "<li id='" + j + "'><a>" + array[singleRow]['data'][j]['name'] + "</a></li>";
    }
    html += city + name_store + "</ul></div>";
  }
  $("#list_store").html(html);

  // Mostrar info del primer local
  actualizarPanel(0, 0);

  // --- NUEVO: avisar que los datos están listos e intentar mover el mapa ---
  datosListos = true;
  intentarActualizarMapa(0, 0);
}

// --- NUEVO: solo mover el marcador cuando AMBOS estén listos ---
function intentarActualizarMapa(indiceCiudad, indiceTienda) {
  if (!mapaListo || !datosListos) return; // esperar al otro

  var tienda = array[indiceCiudad]['data'][indiceTienda];
  lat = tienda.lat;
  lng = tienda.lng;

  Latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
  marker_store.setPosition(Latlng);
  marker_store.setVisible(true);
  map_store.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
}

function actualizarPanel(indiceCiudad, indiceTienda) {
  var tienda = array[indiceCiudad]['data'][indiceTienda];
  $('#title-store').html(tienda['name']);
  $('#direction-store').html('<li>' + tienda['direction'] + '</li>');
  $('#email-store').html('<li>' + tienda['email'] + '</li>');
  if (tienda['mobile'] != ' ') $('#mobile-store').html('<li>' + tienda['mobile'] + '</li>');
  if (tienda['service'] != ' ') $('#service-store').html('<li>' + tienda['service'] + '</li>');
  $('#lv-store').html('<li>' + tienda['lv'] + '</li>');
  $('#img-store').html('<img class="img-tiendas" src="' + tienda['img'] + '">');
}

$(document).ready(function () {
  $('body').on('click', '#list_store li', function () {
    var indiceCiudad = $(this).parent().siblings('button').attr('id');
    var indiceTienda = $(this).attr('id');

    actualizarPanel(indiceCiudad, indiceTienda);

    lat = array[indiceCiudad]['data'][indiceTienda]['lat'];
    lng = array[indiceCiudad]['data'][indiceTienda]['lng'];

    Latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    marker_store.setPosition(Latlng);
    marker_store.setVisible(true);
    map_store.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
  });
});

function initialize() {
  geocoder_store = new google.maps.Geocoder();
  map_store = new google.maps.Map(document.getElementById("map-store"), {
    center: { lat: lat, lng: lng },
    zoom: 12
  });

  Latlng = new google.maps.LatLng(lat, lng);
  infoWindows_store = new google.maps.InfoWindow();
  marker_store = new google.maps.Marker({
    map: map_store,
    anchorPoint: new google.maps.Point(0, -29)
  });

  marker_store.setPosition(Latlng);
  marker_store.setVisible(true);

  // --- NUEVO: avisar que el mapa está listo e intentar mover el marcador ---
  mapaListo = true;
  intentarActualizarMapa(0, 0);
}

function quitarAcentos(cadena) {
  const acentos = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U' };
  return cadena.split('').map(letra => acentos[letra] || letra).join('').toString();
}

function capitalize(s) {
  s = s.toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}